"use strict";

export default angular.module("contartemx.bancos.traspasos", [
	"contartemx",
	"ngTable",
	"ui.router",
	"ui.bootstrap",
	"datePicker",
	"tableTools",
	"loader"
])

.controller("TraspasosCtrl", function ($scope, $state, mostrarNotificacion, $stateParams, dateTools, callToWebService, NgTableParams, $filter, $http, $uibModal, ServicioBusqueda) {
    
    $scope.selectedOpt = 0;
    $scope.noTieneTraspasos = false;

    $scope.busqueda = {};
    $scope.busqueda.nombreCuenta = ServicioBusqueda.BancosTraspasos.get("NombreCuenta");
    $scope.busqueda.fDate = ServicioBusqueda.BancosTraspasos.get("FechaInicio");
    $scope.busqueda.tDate = ServicioBusqueda.BancosTraspasos.get("FechaFin");

    $scope.fDate = dateTools.getDateStringFromWCF(ServicioBusqueda.BancosTraspasos.get("FechaInicio"));
    $scope.tDate = dateTools.getDateStringFromWCF(ServicioBusqueda.BancosTraspasos.get("FechaFin"));

      $scope.estadoTraspaso = function (i) {
        $scope.selectedOpt = i;
        switch (i) {
            case 0:
                $scope.estadoTrasp = "Activos";
                ServicioBusqueda.BancosTraspasos.set("EstaActivo", true);
                $scope.traspasosActivos = true;
                obtenerListadoTraspasos();
                break;
            case 1:
                $scope.estadoTrasp = "Cancelados";
                ServicioBusqueda.BancosTraspasos.set("EstaActivo", false);
                $scope.traspasosActivos = false;
                obtenerListadoTraspasos();
                break;
        }
    };

    $scope.estadoTraspaso(ServicioBusqueda.BancosTraspasos.get('EstaActivo') ? 0 : 1);

    function obtenerListadoTraspasos() {
        $scope.loading = true;
        callToWebService.postCall('ObtenerPantallaListadoTraspasos', { opciones: ServicioBusqueda.BancosTraspasos.get() },
        function sucess(data) {
            if(data.CodigoRespuesta == 200){
                $scope.traspasos = data.Respuesta.ListadoTraspasos;
                $scope.noTieneTraspasos = $scope.traspasos.length == 0;
                $scope.cuentas = data.Respuesta.Cuentas;
                $scope.monedas = data.Respuesta.Monedas;
                $scope.loading = false;
                $scope.noMoreResults = ($scope.traspasos.length < ServicioBusqueda.BancosTraspasos.get("CantidadRegistrosSolicitados"));
                $scope.noTieneResultados = data.Respuesta.NoTieneResultados;
            }else{
                $scope.loading = false;
                mostrarNotificacion.error(data.Mensaje);
                $scope.noTieneTraspasos = true;
            }

        },
        function error(data){
            mostrarNotificacion.error(data.Mensaje);
            $scope.loading = false;
            $scope.noTieneTraspasos = true;
        });
    }

    $scope.noMoreResults = false;
    $scope.showMore = function () {
        $scope.tableParams.count($scope.tableParams.count() + 15);
        ServicioBusqueda.BancosTraspasos.set("CantidadRegistrosSolicitados", ServicioBusqueda.BancosTraspasos.get("CantidadRegistrosSolicitados") + 15);
        obtenerListadoTraspasos();
    };
    
    $scope.mostrarDetalle = function(){
        for(var x = 0 ;x < $scope.traspasos.length ;x++){
            $(".popover--descripcion[Indice='" + x + "']").addClass("popover--hidden");
        }
        var indexPop = $scope.selectedRow;   
        $(".popover--descripcion[Indice='" + $scope.selectedRow + "']").removeClass("popover--hidden");
        $("#context-menu").removeClass("open");
    };

    $scope.mostrarCancelarPop = function () {
        for(var x = 0 ;x < $scope.traspasos.length ;x++){
            $(".popover--Cancel[Indice='" + x + "']").addClass("popover--hidden");
        }
        var indexPop = $scope.selectedRow;   
        $(".popover--Cancel[Indice='" + $scope.selectedRow + "']").removeClass("popover--hidden");
        $("#context-menu").removeClass("open");
    };

    $scope.mostrarActivarPop = function(){
        for(var x = 0 ;x < $scope.traspasos.length ;x++){
            $(".popover--Activar[Indice='" + x + "']").addClass("popover--hidden");
        }
        var indexPop = $scope.selectedRow;   
        $(".popover--Activar[Indice='" + $scope.selectedRow + "']").removeClass("popover--hidden");
        $("#context-menu").removeClass("open");
    };

    $scope.cambiarEstadoTraspaso = function(ClaveTransaccion, opc){

        if(opc == 0){
            var llamadoCambiar = 'CancelarTraspaso';
        }else{
            var llamadoCambiar = 'ActivarTraspaso';
        }

    callToWebService.postCall(llamadoCambiar, { claveTraspaso: ClaveTransaccion},
        function sucess(data){
            if(data.CodigoRespuesta == 200){
                mostrarNotificacion.info(data.Mensaje);
                 obtenerListadoTraspasos();
            }else{
                mostrarNotificacion.info(data.Mensaje);
            }
            
        },
        function error(data){
          mostrarNotificacion.info(data.Mensaje);
        });
    };

    $scope.select = function (index) {
        $scope.selectedRow = index;
    };

    $scope.deselect = function () {
        $scope.selectedRow = -1;
    };

    $scope.eliminarFiltro = function (opciones) {
        if (angular.isObject(opciones)) {
            var actualizarLista = true;

            switch(opciones.filtro) {
                case 'NombreCuenta':
                    $scope.busqueda.nombreCuenta = null;
                    break;
                case 'Fecha':
                    $scope.fDate = null;
                    $scope.tDate = null;
                    ServicioBusqueda.BancosTraspasos.unset("FechaInicio");
                    ServicioBusqueda.BancosTraspasos.unset("FechaFin");
                    break;
                default:
                    actualizarLista = false;
                    break;
            }

            if (actualizarLista) {
                obtenerListadoTraspasos();
            }

        }
    }

    $scope.onFromDateSelect = function (fromDateString) {
        $scope.busqueda.fDate = $scope.Movil ? dateTools.getTimeForWCF(fromDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(fromDateString, 'DD/MM/YY');
        $scope.fDate = fromDateString;
    }

    $scope.onToDateSelect = function (toDateString) {
        $scope.busqueda.tDate = $scope.Movil ? dateTools.getTimeForWCF(toDateString, 'YYYY-MM-DD') : dateTools.getTimeForWCF(toDateString, 'DD/MM/YY');
        $scope.tDate = toDateString;
    }
       
    $scope.addSearchCriteria = function (form) {

        var nombreCuenta = $scope.busqueda.nombreCuenta;
        var fDate = $scope.busqueda.fDate;
        var tDate = $scope.busqueda.tDate;

        if ($scope.fDate && fDate && $scope.tDate && tDate) {
            ServicioBusqueda.BancosTraspasos.set({
                FechaInicio: fDate,
                FechaFin: tDate
            });
        } else {
            ServicioBusqueda.BancosTraspasos.unset("FechaInicio");
            ServicioBusqueda.BancosTraspasos.unset("FechaFin");
        }
    
        if (angular.isString(nombreCuenta) && nombreCuenta.length > 0) {
            ServicioBusqueda.BancosTraspasos.set("NombreCuenta", nombreCuenta);
        } else {
            ServicioBusqueda.BancosTraspasos.unset("NombreCuenta");
        }

        obtenerListadoTraspasos();
    };

    $scope.removeSearchCriteria = function () {
        $scope.busqueda = {};
        $scope.fDate = null;
        $scope.tDate = null;
        ServicioBusqueda.BancosTraspasos.reset();
        $scope.estadoTraspaso(ServicioBusqueda.BancosTraspasos.get('EstaActivo') ? 0 : 1);
    };

    $scope.tableParams = new NgTableParams({
        page: 1,
        total: 1,
        count: 15,
        counts: [],
        sorting: {
            Fecha: "asc"
        }
    });

    $scope.$watch('tableParams', function (params, paramsOld) {
        let _params = params._params;
        if (params != paramsOld && params && _params.sorting) {
            $scope.traspasos = $filter('orderBy')($scope.traspasos, params.orderBy());
        }
    }, true);
    
    $scope.displayPopup = function () {
        var modalInstance = $uibModal.open({
            template: require('../../../../../app/views/Bancos/Traspasos/Traspasos_modal.html'),
            controller: TraspasosModalCtrl,
          windowClass: 'modal--small',
          openedClass: 'overflow-y-hidden',
          appendTo: angular.element(document.querySelector('.modal-parent')),
            resolve:{
                cuentas: function(){
                    return $scope.cuentas;
                },
                monedas: function(){
                    return $scope.monedas;
                },
                esMovil: function () {
                    return $scope.Movil;
                }
            }
        });
        modalInstance.result.then(function (data) {
            if (data !== null) {
                mostrarNotificacion.info(data.Mensaje);
                obtenerListadoTraspasos();
            }
        });
    };

    var TraspasosModalCtrl = function ($scope, $uibModalInstance, callToWebService, cuentas, monedas, esMovil) {
        $scope.cuentasTraspaso = cuentas;
        for(var i in $scope.cuentasTraspaso){
            var clv = $scope.cuentasTraspaso[i].NumeroDeCuenta.toString();
            if(clv != 0 && clv.length > 3)
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv.substr(clv.length-4);
            else 
                $scope.cuentasTraspaso[i].NumeroDeCuenta = clv;
        }
        if(esMovil)
        {
            $scope.Movil = true;
            $scope.fechaTraspaso = moment().format('YYYY-MM-DD');
        }else{
            $scope.Movil = false;
            $scope.fechaTraspaso = moment().format('DD/MM/YY');
        }
        $scope.monedasTraspaso = monedas;

        $scope.monedaActual = {};
        $scope.monedaActual.Codigo = 'MXN';
        $scope.monedaActual.CveMoneda = 1;
        $scope.$watch('monedaActual', function (moneda) {
            var cve = $scope.monedaActual.CveMoneda;
            for (var n = 0; n < $scope.monedasTraspaso.length; n++) {
                if (cve == $scope.monedasTraspaso[n].CveMoneda) {
                  
                    $scope.tipoDeCambioActivo = $scope.monedasTraspaso[n].Valor.toFixed(2);
                    $scope.cveMonedaTraspaso = $scope.monedasTraspaso[n].CveMoneda;
                }
            }
        });

        $scope.valOrigen = '';
        $scope.valDestino = '';
        $scope.closeModal = function () {
            $uibModalInstance.close(null);
        };

        $scope.closeModalAlert = function (i) {
            $scope.alert.splice(i, 1);
        };

        $scope.cuentaDestino = function(nom){
            $scope.valDestino = nom;
        };

        $scope.cuentaOrigen = function(nom){
            $scope.valOrigen = nom;
        };

        $scope.ImporteSalidaOnChange = function () {
            if ( $scope.importeDestinoCodigo != '' ) {
                if ( $scope.codMonedasMXN || $scope.sonMonedasIguales ) {
                    $scope.importeDestinoValue = $scope.importe;
                }
            }
        };

        $scope.TipoCambioOrigenOnChange = function () {
            if ( $scope.TipoCambioOrigen != '' ) {
                if ( $scope.codMonedaOrigenMXN ) {
                    $scope.TipoCambioOrigen = 1;
                    $scope.TipoCambio = 1;
                }
                if ( $scope.sonMonedasIguales ) {
                    $scope.TipoCambio = $scope.TipoCambioOrigen;
                }
            }
        };

        $scope.TipoCambioOnChange = function () {
            if ( ( $scope.TipoCambioOrigen !== "" ) && ( $scope.importe !== "" ) ) {
                if ( $scope.codMonedaDestinoMXN ) {
                    $scope.TipoCambio = 1;
                }
                $scope.Equivalencia = ( $scope.TipoCambioOrigen / $scope.TipoCambio ).toFixed(10);
                $scope.importeDestinoValue = ( ( $scope.Equivalencia * $scope.TipoCambio ) * ( $scope.importe / $scope.TipoCambio ) ).toFixed(6);
            }
        };

        $scope.ImporteDestinoOnChange = function () {
            if ( ( $scope.importe !== "" ) && ( $scope.importeDestinoValue !== "" ) ) {
                $scope.TipoCambio = ($scope.codMonedaDestinoMXN ) ? 1 : ((($scope.importe*$scope.TipoCambioOrigen) / $scope.importeDestinoValue).toFixed(6));
                $scope.Equivalencia = ( $scope.TipoCambioOrigen / $scope.TipoCambio ).toFixed(10);
            }
        };

        $scope.invertirOrigen = function () {
            var origenSelected = $scope.valOrigen;
            var destinoSelected = $scope.valDestino;
            $scope.valOrigen = destinoSelected;
            $scope.valDestino = origenSelected;

        };

        $scope.importeDestino = false; 
        $scope.importeOrigenCodigo = "";
        $scope.importeDestinoCodigo = "";

        //
        $scope.sonMonedasIguales = false;
        $scope.codMonedaOrigenMXN = false;
        $scope.codMonedaDestinoMXN = false;
        $scope.codMonedasMXN = false;

        //
        $scope.$watch('valOrigen', function (params, paramsOld) {
            if(params != "") {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeOrigenCodigo = monedas[m].Codigo;
                            }
                                

                        }

                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }
                    else{
                        $scope.sonMonedasIguales = false;
                    }
                }
                else{
                    $scope.sonMonedasIguales = true;
                }
            }
            else{
                $scope.importeOrigenCodigo = "";
                $scope.sonMonedasIguales = true;
            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }

            //
            $scope.codMonedaOrigenMXN = $scope.importeOrigenCodigo == "MXN";
            $scope.importe = "";
            $scope.TipoCambioOrigen = ( $scope.importeOrigenCodigo == "MXN") ? "1" : "";
        });

        //
        $scope.$watch('valDestino', function (params, paramsOld) {
            if(params != "") {
                for(var x = 0;x < $scope.cuentasTraspaso.length;x++){
                    if(params == $scope.cuentasTraspaso[x].CveCuentaDeBanco){
                        for(var m = 0 ; m<monedas.length ; m++){
                            if($scope.cuentasTraspaso[x].CveMoneda == monedas[m].CveMoneda){
                                $scope.importeDestinoCodigo = monedas[m].Codigo;
                            }
                                
                        }

                    }
                }
                if($scope.importeOrigenCodigo != $scope.importeDestinoCodigo){
                    if($scope.valOrigen == "" || $scope.valDestino ==""){
                        $scope.sonMonedasIguales = true;
                    }else{
                        $scope.sonMonedasIguales = false;
                    }
                }
                else{
                    $scope.sonMonedasIguales = true;
                }
            }
            else{
                $scope.importeDestinoCodigo = "";
                $scope.sonMonedasIguales = true;

            }
            if( params == undefined)
            {
                $scope.sonMonedasIguales = true;
            }

            //
            $scope.codMonedaDestinoMXN = $scope.importeDestinoCodigo == "MXN";
            $scope.Equivalencia = "";
            $scope.importeDestinoValue = "";
            $scope.TipoCambio = ( $scope.importeDestinoCodigo == "MXN") ? "1" : "";
            if ($scope.sonMonedasIguales) {
                $scope.ImporteSalidaOnChange();
                $scope.TipoCambioOrigenOnChange();
                $scope.TipoCambioOnChange();
                $scope.ImporteDestinoOnChange();
            }
        });

        $scope.guardarTraspaso = function(form){
            var monedaTipoCambioValidos = false;
            if(form.$valid){
                var ctaOrigen = form.cuentaOrigen.$viewValue ? form.cuentaOrigen.$viewValue : null;
                var ctaDestino = form.cuentaDestino.$viewValue ? form.cuentaDestino.$viewValue : null;
                var importeTraspaso = form.importe.$viewValue ? form.importe.$viewValue : null;
                var importeDestinoValue = form.importeDestinoValue.$viewValue ? form.importeDestinoValue.$viewValue : null;
                var TipoCambio = form.TipoCambio.$viewValue ? form.TipoCambio.$viewValue : null;
                if($scope.sonMonedasIguales)
                {
                    importeDestinoValue = importeTraspaso;
                }
                var fechaTraspaso = $('#fechaTraspaso').val();

                var descripcionTraspaso = form.descripcion.$viewValue ? form.descripcion.$viewValue : null;
                var fecha;

                if(ctaOrigen && ctaDestino && importeTraspaso && importeDestinoValue && TipoCambio && fechaTraspaso){
        
                    if(ctaOrigen != ctaDestino){
                        if(esMovil)
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'YYYY-MM-DD');
                    else
                        fecha = dateTools.getTimeForWCF(fechaTraspaso,'DD/MM/YY');
                    var generarTraspaso = {
                        ClaveCuentaOrigen:ctaOrigen,
                        ClaveCuentaDestino:ctaDestino,
                        MontoOrigen:importeTraspaso,
                        MontoDestino:importeDestinoValue,
                        TipoCambio:TipoCambio,
                        Fecha:fecha,
                        Descripcion:descripcionTraspaso
                    };
                    callToWebService.postCall('GenerarTraspaso', { traspaso: generarTraspaso},
                    function sucess(data){
                        if(data.CodigoRespuesta == 200){
                            $uibModalInstance.close(data);
                        }else{
                            $scope.alert = [];
                            $scope.alert.push({ type: 'error', msg: data.Mensaje});
                        }
                        
                    },
                    function error(data){
                       $scope.alert = [];
                       $scope.alert.push({ type: 'error', msg: data.Mensaje});
                    });
                    }else{
                        $scope.alert = [];
                        $scope.alert.push({ type: 'error', msg: 'La cuentas Origen y Destino deben ser distintas.'});
                    }
                    
                }else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            
                }
            }
            else{
                $scope.alert = [];
                $scope.alert.push({ type: 'error', msg: 'Faltan datos, ingresa los datos donde aparece el símbolo verde.'});
            }
        };
    };
});




